<template>
  <v-card>
    <v-card-title primary-title class="greyk lighten-4l">
      <h4 class="headline mb-0">{{ $t("settings") }}</h4>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab v-for="item in tabitems" :key="item">{{ item }}</v-tab>
      </v-tabs>
      <v-divider></v-divider>

      <v-tabs-items v-model="tab">
        <!-- school settings tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <!-- school settings inside tabs-->
              <v-layout>
                <v-item-group
                  v-model="schoolwindow"
                  class="shrink mr-2"
                  mandatory
                  tag="v-flex"
                >
                  <v-item v-for="(n, index) in schooltabs" :key="index">
                    <div slot-scope="{ active, toggle }">
                      <v-btn :input-value="active" @click="toggle(n)">
                        {{ n }}
                      </v-btn>
                    </div>
                  </v-item>
                </v-item-group>

                <v-flex>
                  <!-- school settings inside tabs-->
                  <v-window v-model="schoolwindow" class="elevation-1" vertical>
                    <v-window-item>
                      <school-info></school-info>
                    </v-window-item>
                    <v-window-item>
                      <academic-years></academic-years>
                    </v-window-item>
                    <v-window-item>
                      <terms></terms>
                    </v-window-item>
                    <v-window-item>
                      <subjects />
                    </v-window-item>
                    <v-window-item>
                        <class-assessment></class-assessment>
                    </v-window-item>
                    <v-window-item>
                      <admins></admins>
                    </v-window-item>
                  </v-window>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Fees settings tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-layout>
                <v-item-group
                  v-model="feeswindow"
                  class="shrink mr-2"
                  mandatory
                  tag="v-flex"
                >
                  <v-item v-for="(n, index) in feestabs" :key="index">
                    <div slot-scope="{ active, toggle }">
                      <v-btn :input-value="active" @click="toggle(n)"> 
                        {{ n }}
                      </v-btn>
                    </div>
                  </v-item>
                </v-item-group>

                <v-flex>
                  <!-- fees settings inside tabs-->
                  <v-window v-model="feeswindow" class="elevation-1" vertical>
                    <v-window-item>
                      <fees-structure></fees-structure>
                    </v-window-item>
                    <v-window-item>
                      <additional-charges></additional-charges>
                    </v-window-item>
                    <v-window-item>
                      <fees-discount></fees-discount>
                    </v-window-item>
                    <v-window-item>
                      <fees-alert></fees-alert>
                    </v-window-item>
                    <v-window-item>
                      <ledgeraccs></ledgeraccs>
                    </v-window-item>
                  </v-window>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- sms settings tab -->
        <!-- <v-tab-item>
          <v-card flat>
            <v-card-text>
              <sms-settings>

              </sms-settings>
            </v-card-text>
          </v-card>
        </v-tab-item> -->
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>


<script>
import VerticalTabs from "../../../components/VerticalTabs";
import ClassGen from "../../../components/settings/classGen";
import ClassSections from "../../../components/settings/classSections";
import AccYears from "../../../components/settings/schoolAcademicYears";
import terms from "../../../components/settings/schoolTerms";
import fstruct from "../../../components/settings/feesStructure";
import fdiscs from "../../../components/settings/feesDiscounts";
import additionalCharges from "../../../components/settings/feesAdditionalCharges";
import feesAlert from "../../../components/settings/feesAlert";
import ledgeraccs from "../../../components/settings/ledgeraccs";
//import sms from "../../../components/settings/sms";
import schoolInfo from "../../../components/settings/schoolInfo";
import classAssessment from "../../../components/settings/class_assessment";
import subjects from "../../../components/settings/subject";
import adminAccounts from "../../../components/settings/adminAccounts";
import Class_assessment from '../../../components/settings/class_assessment.vue';

export default {
  name: "settings-view",
  components: {
    "vertical-tabs": VerticalTabs,
    "class-gen": ClassGen,
    "class-sections": ClassSections,
    "academic-years": AccYears,
    terms: terms,
    "fees-structure": fstruct,
    "fees-discount": fdiscs,
    "additional-charges": additionalCharges,
    // "sms-settings":sms,
    "school-info": schoolInfo,
    "class-assessment":classAssessment,
    subjects: subjects,
    admins: adminAccounts,
    "fees-alert": feesAlert,
    ledgeraccs: ledgeraccs,
   
  },
  metaInfo() {
    return { title: this.$t("settings") };
  },
  methods: {
    setTab2Selected(val) {
      this.tab2 = val;
    },
    setTab3Selected(val) {
      this.tab3 = val;
    },
    setTab4Selected(val) {
      this.tab4 = val;
    },
  },
  data() {
    return {
      schoolwindow: 0,
      feeswindow: 0,
      verticalText: false,
      containerStyle: "",
      searcht: "",
      searcho: "",
      tab: null,
      tab2: null,
      tab3: null,
      tab4: null,
      tabitems: [
        "General Settings", //was previously school settings
        // "Class Settings",
        "Financial Settings",
        //"SMS Settings"
      ],
      schooltabs: [
        "School Info",
        "Academic Years",
        "Academic Terms",
        "Subjects",
        "Grading System",
        "Admin. Accounts",
      ],
      classtabs: ["General", "Class Sections"],
      feestabs: [
        "Fees Structures",
        "Additional Charges",
        "Fees Discounts",
        "Fee payment Alert",
        "Ledger Accounts",
      ],
    };
  },
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/pages/shared/settings/settings.vue